import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "header"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("div", {
    staticClass: "newsInfo"
  }, [_c("div", {
    staticClass: "noticeLog"
  }), _c("el-carousel", {
    staticClass: "swiper-wrapper",
    staticStyle: {
      "overflow-y": "visible",
      "overflow-x": "visible"
    },
    attrs: {
      direction: "vertical",
      height: "40px"
    }
  }, _vm._l(_vm.news, function (news, index) {
    return _c("el-carousel-item", {
      key: index,
      staticClass: "swiper-slide"
    }, [_c("div", {
      staticClass: "title item",
      on: {
        click: function ($event) {
          return _vm.goNewsDetDetail(news.id);
        }
      }
    }, [_vm._v(" " + _vm._s(news.title) + " ")])]);
  }), 1)], 1), _c("div", {
    staticClass: "userInfo"
  }, [_c("div", {
    staticClass: "userItem",
    on: {
      click: function ($event) {
        return _vm.toRoutePage("/goods-cart");
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/img/cartred@2x.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "cartText"
  }, [_vm._v("购物车")]), _c("span", {
    staticClass: "cartCount"
  }, [_vm._v(_vm._s(_vm.$store.state.userCartCount) + "件")])]), _c("div", {
    staticClass: "userItem",
    on: {
      click: function ($event) {
        return _vm.toRoutePage("/order-search");
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/img/home/order-red@2x.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("我的订单")])]), _vm.$store.state.token ? _c("div", {
    staticClass: "userItem"
  }, [_c("div", {
    staticClass: "userName",
    on: {
      click: _vm.togglebox
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$store.state.user.nickName || _vm.$store.state.user.userMobile))]), _c("i", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isSpread,
      expression: "!isSpread"
    }],
    staticClass: "el-icon-arrow-down"
  }), _c("i", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSpread,
      expression: "isSpread"
    }],
    staticClass: "el-icon-arrow-up"
  })]), _c("transition", {
    attrs: {
      name: "mybox"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.boxshow,
      expression: "boxshow"
    }],
    staticClass: "userDetail"
  }, [_c("div", {
    on: {
      click: function ($event) {
        return _vm.toOtherOperate("feedback");
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/img/home/feedback-black@2x.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("提交意见")])]), _c("div", {
    on: {
      click: function ($event) {
        return _vm.toOtherOperate("chat");
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/img/home/customerService-black@2x.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("在线客服")])]), _c("div", {
    on: {
      click: function ($event) {
        return _vm.toOtherOperate("password");
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/img/home/changePassword-black@2x.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("修改密码")])]), _c("div", {
    on: {
      click: function ($event) {
        return _vm.toOtherOperate("exit");
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/img/home/exit-black@2x.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("退出登录")])])])])], 1) : _c("div", {
    staticClass: "userItem"
  }, [_c("span", {
    staticClass: "userLogin",
    on: {
      click: function ($event) {
        return _vm.$router.push("/login");
      }
    }
  }, [_vm._v("登录")]), _c("span", [_vm._v(" / ")]), _c("span", {
    staticClass: "userRegister",
    on: {
      click: function ($event) {
        return _vm.$router.push("/register");
      }
    }
  }, [_vm._v("注册")])])])]), _c("div", {
    staticClass: "menuBox"
  }, [_c("div", {
    staticClass: "logo"
  }, [_c("img", {
    staticClass: "logo",
    attrs: {
      src: "https://qlcnbook-console.oss-cn-beijing.aliyuncs.com/2023/10/6528f8dcc13f447b9b4e0d69ed056e93.png?123"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push("/home");
      }
    }
  })]), _c("div", {
    staticClass: "menuDetail"
  }, [_c("Menu")], 1)]), _c("div", {
    staticClass: "backmenu-interval"
  }), _c("Feedback", {
    ref: "Feedback"
  }), _c("ChangePassword", {
    ref: "ChangePassword",
    on: {
      toOtherOperate: _vm.toOtherOperate
    }
  }), _c("ServiceQRcode", {
    ref: "ServiceQRcode"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };